import { styled, utilities } from '@creditas/stylitas';
import { Grid } from '@creditas/layout';

interface GridItemProps {
  item: boolean;
  colStart: number;
  colEnd: number;
  xsColStart?: number;
  xsColEnd?: number;
  mdColStart?: number;
  mdColEnd?: number;
  lgColStart?: number;
  lgColEnd?: number;
}

export const Container = styled.div`
  position: relative;
  display: flex;
  border-top: 5px solid
    ${(props): string => utilities.palette.color(props.theme, 'neutral02')};
`;

export const SideBar = styled.div`
  width: 0%;
  height: 100vh;
  background-color: ${(props): string =>
    utilities.palette.color(props.theme, 'neutral02')};
  transition: width 0.2s;
  overflow: hidden;
  > div {
    margin: 15% auto 0px;
    width: 70%;
  }
  @media only screen and (min-width: 768px) {
    width: 30%;
  }
`;

export const FormContainer = styled.div`
  position: relative;
  max-width: 1200px;
  margin: 0px 5%;
  .header-text__desc {
    display: block;
  }
  @media only screen and (min-width: 768px) {
    .header-text__desc {
      display: none;
    }
  }
`;

export const Layout = styled(Grid)`
  margin: 32px 0 90px 0;
  grid-row-gap: 48px;
`;

export const RGridItem = styled(Grid)<GridItemProps>`
  grid-column-start: ${(props: GridItemProps): number => props.colStart};
  grid-column-end: span ${(props: GridItemProps): number => props.colEnd};

  @media only screen and (min-width: 480px) {
    grid-column-start: ${(props: GridItemProps): number =>
      props.xsColStart ? props.xsColStart : props.colStart};
    grid-column-end: span
      ${(props: GridItemProps): number =>
        props.xsColEnd ? props.xsColEnd : props.colEnd};
  }
  @media only screen and (min-width: 768px) {
    grid-column-start: ${(props: GridItemProps): number =>
      props.mdColStart ? props.mdColStart : props.colStart};
    grid-column-end: span
      ${(props: GridItemProps): number =>
        props.mdColEnd ? props.mdColEnd : props.colEnd};
  }
  @media only screen and (min-width: 1200px) {
    grid-column-start: ${(props: GridItemProps): number =>
      props.lgColStart ? props.lgColStart : props.colStart};
    grid-column-end: span
      ${(props: GridItemProps): number =>
        props.lgColEnd ? props.lgColEnd : props.colEnd};
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;

  margin: 32px 0;
  justify-content: flex-end;

  @media only screen and (max-width: 1170px) {
    padding: 0px 70px 0px;
  }

  @media only screen and (max-width: 760px) {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 0px;
    margin: 0px;
    > button {
      width: 100%;
      border-radius: 0;
    }
  }
`;

export const FormFooter = styled(Grid)`
  grid-row-gap: 36px;
  margin-bottom: 70px;
`;

export const FormLink = styled.a`
  position: relative;

  object-fit: contain;
  line-height: 1.5;

  color: ${(props): string =>
    utilities.palette.color(props.theme, 'secondary05')};
  font-size: 18px;
  font-weight: bold;
  text-decoration: none;

  :after {
    position: absolute;

    height: 1px;
    width: 100%;
    margin: 0 auto;
    content: '';
    left: 0;
    right: 0;
    left: 0;
    bottom: 2px;

    color: #000;
    background-color: ${(props): string =>
      utilities.palette.color(props.theme, 'secondary05')};
  }
`;
